export var FooterType;
(function (FooterType) {
    FooterType["DEFAULT"] = "default";
    FooterType["SHORT"] = "default_short";
    FooterType["SHORT_WITHOUT_SOCIAL"] = "default_short_without_social";
    FooterType["WEBAPP"] = "default_webapp";
})(FooterType || (FooterType = {}));
